import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { DifficultSituation } from '../components/DifficultSituation';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { Trajectory } from '../components/Trajectory';
import { MaestroJohn } from '../components/MaestroJohn';
import { LoveGuidance } from '../components/LoveGuidance';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Policies } from '../components/Policies';
import { Footer } from '../components/Footer';
import { MobileActionBar } from '../components/MobileActionBar';
import { useTawkTo } from '../hooks/useTawkTo';
interface LandingProps {
  lockup: string;
  showTestimonials: boolean;
  showConsultationCount: boolean;
  freeInitialConsultation: boolean;
}
export function Landing({
  lockup,
  showTestimonials,
  showConsultationCount,
  freeInitialConsultation
}: LandingProps) {
  useTawkTo();
  return <div className="min-h-full w-full bg-carbon font-sans" data-id="element-210" data-mp="3tgbj3xd0vcvy">
      <Header lockup={lockup} data-id="element-211" data-mp="3tf0clps6zr15" />
      <main data-id="element-212" data-mp="3peq86hk1t8oe">
        <MobileActionBar data-id="element-213" data-mp="3pegjcxaqp7ka" />
        <Hero lockup={lockup} data-id="element-214" data-mp="3pfriukx5jt5l" />
        <Intro data-id="element-215" data-mp="3pezwm0pg37rz" />
        <DifficultSituation data-id="element-216" data-mp="3pgksbtnhwwrf" />
        <Services data-id="element-217" data-mp="3kg6nekh6y2xm" />
        <LoveGuidance data-id="element-218" data-mp="3kgomrpz5gx9r" />
        {showTestimonials ? <Testimonials data-id="element-219" data-mp="3khzug0vpup65" /> : null}
        <Trajectory showConsultationCount={showConsultationCount} data-id="element-220" data-mp="l11h0p94u7o6" />
        <MaestroJohn data-id="element-221" data-mp="l2cksp2kvffa" />
        <FinalCTA freeInitialConsultation={freeInitialConsultation} data-id="element-222" data-mp="gyeloed964m8" />
        <Contact data-id="element-223" data-mp="h1ajm2p3otao" />
        <Policies data-id="element-224" data-mp="c7y90wh9an0x" />
      </main>
      <Footer lockup={lockup} data-id="element-225" data-mp="c76dflnnspan" />
    </div>;
}